module.exports = __webpack_public_path__ + "img/recesso_bra_consultoria.33d3f3d5.webp";